import React from "react";
const ErrorExclamation = (props) => {
    return (React.createElement("div", { className: `${props.parentClass ? props.parentClass : "mt-2"}` },
        React.createElement("div", { className: `invalidMsg ${!props.avoidBackground && "bg_lightPinkTwo change-bg-pastal"}` },
            React.createElement("div", { className: ` ${props.childClass ? props.childClass : ""} DMSansNormal_12_400 txt_bloodRed  d-flex align-items-center` },
                !props.avoidExclamation && (React.createElement("div", { className: "edel-icon-validation" })),
                React.createElement("div", { className: "p-1" }, props.errorMessage)))));
};
export default ErrorExclamation;
